var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning",class:{ 'rounded-corners': _vm.rounded }},[_c('div',{staticClass:"icon"},[_c('use-svg',{staticClass:"warning-icon",attrs:{"height":25,"width":25,"svg":"bb-warning-icon"}})],1),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }